export const REVENUE_FIELDS = [
  { key: "rammetilskudd", label: "Rammetilskot", color: "#103766" },
  { key: "inntekts_formuesskatt", label: "Inntekts- og formuesskatt", color: "#3F8A86" },
  { key: "eiendomsskatt", label: "Eigedomsskatt", color: "#D35E4E" },
  { key: "andre_skatteinntekter", label: "Andre skatteinntekter", color: "#E8A34A" },
  { key: "andre_overforinger_stat", label: "Andre overføringar frå staten", color: "#8B5CF6" },
  { key: "overforinger_andre", label: "Overføringar og tilskot frå andre", color: "#8AA4BF" },
  { key: "brukerbetalinger", label: "Brukarbetalingar", color: "#4B647F" },
  { key: "salgs_leieinntekter", label: "Sals- og leigeinntekter", color: "#C98BDB" },
];

export const INVESTMENT_FIELDS = [
  { key: "eiendomsforvaltning", label: "Eigedomsforvaltning", color: "#103766" },
  { key: "var", label: "Vatn, avløp, renovasjon (VAR)", color: "#3F8A86" },
  { key: "grunnskole", label: "Grunnskule", color: "#D35E4E" },
  { key: "helse_omsorg", label: "Helse og omsorg", color: "#E8A34A" },
  { key: "samferdsel", label: "Samferdsel", color: "#8B5CF6" },
  { key: "barnehage", label: "Barnehage", color: "#2A9D8F" },
  { key: "kultur", label: "Kultur", color: "#C98BDB" },
  { key: "kommunale_boliger", label: "Kommunale bustader", color: "#E76F51" },
  { key: "naeringsforvaltning", label: "Næringsforvaltning", color: "#264653" },
  { key: "administrasjon", label: "Administrasjon", color: "#8AA4BF" },
  { key: "plan_byggesak", label: "Plan, byggesak og miljø", color: "#F4A261" },
  { key: "sosialsektoren", label: "Sosialsektoren", color: "#6D597A" },
  { key: "brann_ulykkesvern", label: "Brann- og ulykkesvern", color: "#B56576" },
  { key: "kirke", label: "Kyrkje", color: "#4B647F" },
  { key: "barnevern", label: "Barnevern", color: "#355070" },
  { key: "fellesutgifter", label: "Fellesutgifter", color: "#A8B545" },
  { key: "politisk_styring", label: "Politisk styring", color: "#9C6644" },
];

export const fmt = (num) =>
  num === null || num === undefined ? "—" : new Intl.NumberFormat("nb-NO").format(num);

export const fmtAxis = (value) => {
  const nb = (v, d) => Number(v).toLocaleString("nb-NO", { maximumFractionDigits: d });
  if (Math.abs(value) >= 1000000) return `${nb(value / 1000000, 1)}M`;
  if (Math.abs(value) >= 1000) return `${nb(value / 1000, 0)}k`;
  return `${value}`;
};

export const STORBY_CODES = ["0301", "4601", "5001", "1103"];
export const erStorby = (code) => STORBY_CODES.includes(code);

// Samanlikningsgruppa: storbysnittet for Oslo, Bergen, Trondheim og Stavanger, elles fylkessnittet
export const gruppeInfo = (payload) => {
  const storby = !!payload?.gruppe_namn;
  return {
    storby,
    key: storby ? "Snitt for storbyane" : `Fylkessnitt (${payload?.fylke_name || "fylket"})`,
    kort: storby ? "Storbyane" : "Fylke",
    ord: storby ? "storbygruppa" : "fylket",
    utan: !storby && !!payload?.eige_fylke,
    pct: (r) => (storby ? r?.gruppe_pct : r?.fylke_pct) ?? null,
    count: (r) => (storby ? r?.gruppe_count : r?.fylke_count) ?? null,
  };
};

export const tooltipStyle = { background: "white", border: "1px solid #E6E9F0", borderRadius: "8px" };
